import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import { api, fmtDate, fmtErr } from "@/api";
import { useLang } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function KontributorTab() {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/contributors").then((r) => setItems(r.data)).catch((e) => toast.error(fmtErr(e)));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/contributors", form);
      toast.success(t("common.saved"));
      setForm({ name: "", email: "", password: "" });
      load();
    } catch (err) { toast.error(fmtErr(err)); }
    setBusy(false);
  };

  const remove = async (id) => {
    if (!window.confirm(t("common.confirm_delete"))) return;
    try {
      await api.delete(`/admin/contributors/${id}`);
      toast.success(t("common.deleted"));
      load();
    } catch (err) { toast.error(fmtErr(err)); }
  };

  return (
    <div data-testid="kontributor-tab">
      <form onSubmit={add} className="bg-white rounded-xl border border-emerald-900/10 shadow-sm p-6 max-w-xl space-y-4 mb-8" data-testid="kontributor-form">
        <div>
          <Label className="text-sm font-medium text-slate-700">{t("auth.name")}</Label>
          <Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required className="mt-1.5" data-testid="kontributor-name-input" />
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <Label className="text-sm font-medium text-slate-700">Email</Label>
            <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required className="mt-1.5" data-testid="kontributor-email-input" />
          </div>
          <div>
            <Label className="text-sm font-medium text-slate-700">{t("auth.password")}</Label>
            <Input type="text" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required minLength={8} className="mt-1.5" data-testid="kontributor-password-input" />
          </div>
        </div>
        <Button type="submit" disabled={busy} className="rounded-full bg-emerald-800 hover:bg-emerald-900" data-testid="kontributor-add-submit">
          <Plus className="h-4 w-4 mr-2" /> {busy ? t("common.loading") : t("common.add")}
        </Button>
      </form>

      <div className="space-y-3">
        {items.map((u) => (
          <div key={u.id} className="bg-white rounded-xl border border-emerald-900/10 shadow-sm p-4 flex items-center justify-between gap-4" data-testid={`kontributor-item-${u.id}`}>
            <div>
              <p className="font-semibold text-emerald-950">{u.name}</p>
              <p className="text-xs text-slate-500">{u.email} · {fmtDate(u.created_at, lang)}</p>
            </div>
            <Button size="sm" variant="destructive" onClick={() => remove(u.id)} data-testid={`kontributor-delete-${u.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>
          </div>
        ))}
      </div>
    </div>
  );
}
